import React from 'react'

import { IconProps, iconColor } from './IconProps'

export const ToolsIcon: React.FC<IconProps> = (props) => {
  const { size = 24 } = props
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.6006 21.0751L19.0608 17.9226C19.6437 17.5861 19.9346 17.4178 20.1465 17.1824C20.3341 16.9741 20.4759 16.7288 20.5625 16.4622C20.6602 16.1616 20.6602 15.8258 20.6602 15.1559V8.8417C20.6602 8.1718 20.6602 7.83596 20.5625 7.5354C20.4759 7.26884 20.3341 7.02331 20.1465 6.81502C19.9355 6.58063 19.6453 6.41307 19.0674 6.07945L13.5996 2.92261C13.0167 2.58608 12.7259 2.41816 12.416 2.3523C12.1419 2.29403 11.8584 2.29403 11.5843 2.3523C11.2744 2.41816 10.9826 2.58608 10.3997 2.92261L4.93843 6.07568C4.35623 6.41182 4.06535 6.57975 3.85352 6.81502C3.66597 7.02331 3.52434 7.26884 3.43773 7.5354C3.33984 7.83667 3.33984 8.17338 3.33984 8.84644V15.1514C3.33984 15.8245 3.33984 16.1609 3.43773 16.4622C3.52434 16.7288 3.66597 16.9741 3.85352 17.1824C4.06548 17.4178 4.35657 17.5861 4.93945 17.9226L10.3997 21.0751C10.9826 21.4116 11.2744 21.5796 11.5843 21.6455C11.8584 21.7038 12.1419 21.7037 12.416 21.6455C12.7259 21.5796 13.0177 21.4116 13.6006 21.0751Z'
        stroke={iconColor(props)}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 11.9988C9 13.6556 10.3431 14.9988 12 14.9988C13.6569 14.9988 15 13.6556 15 11.9988C15 10.3419 13.6569 8.99878 12 8.99878C10.3431 8.99878 9 10.3419 9 11.9988Z'
        stroke={iconColor(props)}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
